import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { formatNumber, truncateText } from "../../../../../../utility/helper";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { Pagination } from "../../../../../../components/Stepper/fields/inputField";

const MovementComponent = ({
  viewTransaction,
  viewFutureTransaction,
  handleOptionSelect,
  confirmDelete,
  setLimit,
  limit,
  setPage,
  page,
  userAssetLoading,
  selectedAsset
}) => {
  const [loading, setLoading] = useState(false);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };

  const reasonTemplate = (rowData) => {
    return rowData.remark ? truncateText(rowData.reason, 19) : "-";
  };

  const quantityTemplate = (rowData) => {
    return rowData.quantity ? rowData.quantity : "-";
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none mr-2 ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-primary dark:text-primary"
          }`}
        >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-darkWaring"
          }`}
        >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return moment(rowData.date).format("DD-MM-YYYY");
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.amount ? rowData.amount : "";
    const type = rowData.type?.toUpperCase();

    return type === "OUT" || type === "EXPENSE" ? (
      <>-{formatNumber(cashValue)}</>
    ) : type === "IN" || type === "INCOME" ? (
      <>{formatNumber(cashValue)}</>
    ) : null;
  };

  const CostPriceTemplate = (rowData) => {
    const cashValue = rowData.cost_price || "";
    const type = rowData.type?.toUpperCase();

    if (type === "OUT" || type === "EXPENSE") {
      return cashValue == 0 ? "-" : <>-{formatNumber(cashValue)}</>;
    }

    if (type === "IN" || type === "INCOME") {
      return cashValue == 0 ? "-" : <>{formatNumber(cashValue)}</>;
    }

    return null;
  };

  const LinkedAssetTemplate = (rowData) => {
    return rowData.asset_name ? (
      <div className="">{truncateText(rowData.asset_name, 19)} </div>
    ) : (
      ""
    );
  };

  const balanceTemplate = (rowData) => {
    if (rowData.for_future) {
      return "-";
    }
    const cashValue = rowData.balance;

    if (typeof cashValue === "number") {
      return formatNumber(cashValue);
    }

    return null;
  };

  return (
    <div className="border border-lightPrimary/40 dark:border-info/40 mt-6 pb-4 dark:bg-custom-radial md:px-0 px-4">
      <h2 className="text-2xl font-semibold text-lightPrimary pl-4 py-6 text-black dark:text-primary-gradient inline-block">
        {userAssetLoading ? (
          <div className="h-6 w-40 bg-gray-300 dark:bg-gray-700 rounded animate-pulse" />
        ) :
        selectedAsset?.name ? (
          `CASH - ${selectedAsset.name}`
        ) : (
          "No Asset found"
        )}
      </h2>
      <DataTable
        value={viewTransaction?.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        rows={limit}
        totalRecords={viewTransaction?.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          style={{ width: "16%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="type"
          header="Type"
          style={{ width: "13.6%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "13.6%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="asset_name"
          header="Linked Asset"
          body={LinkedAssetTemplate}
          style={{ width: "18%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          style={{ width: "13%" }}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="balance"
          header="Balance"
          style={{ width: "12%" }}
          body={balanceTemplate}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          style={{ width: "13.8%" }}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
      </DataTable>
      {viewTransaction?.total > limit && (
        <Pagination
          page={page}
          limit={limit}
          total={viewTransaction?.total || 0}
          onPageChange={(newPage) => setPage(newPage)}
        />
      )}
      <div className="mt-5 mb-3 pl-4 font-semibold text-base text-lightPrimary text-black dark:text-primary-gradient inline-block">
        Future
      </div>
      <DataTable
        value={viewFutureTransaction?.transactions}
        className="transaction headerDisble"
        sortMode="multiple"
        rows={limit}
        totalRecords={viewFutureTransaction?.total}
        first={page * limit}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          style={{ width: "16%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="type"
          header="Type"
          style={{ width: "13.6%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          style={{ width: "13.6%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="asset_name"
          header="Linked Asset"
          body={LinkedAssetTemplate}
          style={{ width: "18%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="amount"
          header="Cash"
          body={cashTemplate}
          align="right"
          style={{ width: "13%" }}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="balance"
          header="Balance"
          style={{ width: "12%" }}
          body={balanceTemplate}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          style={{ width: "13.8%" }}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey dark:font-light"
        />
      </DataTable>
    </div>
  );
};

export default MovementComponent;
